import type { RecommendationPriority } from '@ispot/shared'

interface RecItem {
  priority: RecommendationPriority
  title: string
  stageName: string
}

interface ValidationRecommendationsProps {
  items: RecItem[]
}

const dotColor = (priority: RecommendationPriority) => {
  if (priority === 'high') return 'var(--color-danger-fg)'
  if (priority === 'medium') return 'var(--color-market)'
  return 'var(--color-fg-muted)'
}

export function ValidationRecommendations({ items }: ValidationRecommendationsProps) {
  if (items.length === 0) return null
  return (
    <section style={{ marginTop: 28 }}>
      <div
        className="font-mono uppercase text-fg-muted"
        style={{ fontSize: 10, letterSpacing: '0.1em', marginBottom: 10 }}
      >
        Recommendations
      </div>
      <div className="flex flex-col" style={{ gap: 4 }}>
        {items.map((rec, i) => (
          <div
            key={i}
            className="flex items-start text-fg-secondary bg-bg-secondary rounded-md"
            style={{ gap: 9, padding: '7px 11px', fontSize: 12.5 }}
          >
            <span
              style={{
                width: 5,
                height: 5,
                borderRadius: '50%',
                background: dotColor(rec.priority),
                flexShrink: 0,
                marginTop: 5,
              }}
            />
            <span style={{ flex: 1 }}>{rec.title}</span>
            <span
              className="font-mono text-fg-muted self-center"
              style={{
                fontSize: 9,
                textTransform: 'uppercase',
                letterSpacing: '0.06em',
                paddingLeft: 10,
                whiteSpace: 'nowrap',
              }}
            >
              {rec.stageName}
            </span>
          </div>
        ))}
      </div>
    </section>
  )
}
